import TemplateView from '../TemplateView'

export default class Link extends TemplateView {
    constructor({
        extraClass = '',
        text,
        reference = '',
        onClickCallback = () => {},
        dark = false,
    }) {
        super()

        this.text = text
        this.extraClass = extraClass
        this.reference = reference
        this.dark = dark
        this.onClickCallback = onClickCallback
    }

    templateHtml() {
        return `<a href='<%=reference%>'
                    class='components_link <%=extraClass%> <% if (dark) { %>dark<% } %>'
                    target='_blank'
                >
                    <span><%=text%></span>
                    <span class='linkIcon'/>
                </a>`
    }

    afterRender() {
        this.getEl().click(() => this.onClickCallback())
    }
}



// WEBPACK FOOTER //
// ./web/js/components/Link.js